import React, { useState } from 'react';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { useSearchParams } from 'react-router-dom';
import { AppCard, AppPageHeader } from '../../components';
import {
	AccountDialog,
	AccountsTable,
	CreateOrganizationDialog,
	CreateTeamDialog,
	CreateUsersDialog,
	OrganizationsTable,
	TeamsTable,
	UserManagementTable,
} from '../../components/Admin';

type TabValue = 'active' | 'teams' | 'organizations' | 'accounts';
const VALID_TABS: TabValue[] = ['active', 'teams', 'organizations', 'accounts'];

export default function UserManagementPage() {
	const [searchParams, setSearchParams] = useSearchParams();
	const [createUsersOpen, setCreateUsersOpen] = useState(false);
	const [createTeamOpen, setCreateTeamOpen] = useState(false);
	const [createOrganizationOpen, setCreateOrganizationOpen] = useState(false);
	const [createAccountOpen, setCreateAccountOpen] = useState(false);

	const rawTab = searchParams.get('tab') as TabValue | null;
	const tab: TabValue = rawTab && VALID_TABS.includes(rawTab) ? rawTab : 'active';

	const handleTabChange = (_: React.SyntheticEvent, value: TabValue) => {
		setSearchParams(value === 'active' ? {} : { tab: value }, { replace: true });
	};

	return (
		<>
			<AppPageHeader>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
					<Typography variant="h5">User Management</Typography>
					{tab === 'active' && (
						<Button variant="contained" startIcon={<PersonAddIcon />} onClick={() => setCreateUsersOpen(true)}>
							New Users
						</Button>
					)}
					{tab === 'teams' && (
						<Button variant="contained" startIcon={<GroupAddIcon />} onClick={() => setCreateTeamOpen(true)}>
							New Team
						</Button>
					)}
					{tab === 'organizations' && (
						<Button
							variant="contained"
							startIcon={<AddBusinessIcon />}
							onClick={() => setCreateOrganizationOpen(true)}
						>
							New Organization
						</Button>
					)}
					{tab === 'accounts' && (
						<Button variant="contained" startIcon={<BusinessCenterIcon />} onClick={() => setCreateAccountOpen(true)}>
							New Account
						</Button>
					)}
				</Box>
			</AppPageHeader>
			<AppCard>
				<Tabs value={tab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
					<Tab label="Active Users" value="active" />
					<Tab label="Accounts" value="accounts" />
					<Tab label="Teams" value="teams" />
					<Tab label="Organizations" value="organizations" />
				</Tabs>
				{tab === 'active' && <UserManagementTable />}
				{tab === 'teams' && <TeamsTable />}
				{tab === 'organizations' && <OrganizationsTable />}
				{tab === 'accounts' && <AccountsTable />}
			</AppCard>
			<CreateUsersDialog open={createUsersOpen} onClose={() => setCreateUsersOpen(false)} />
			<CreateTeamDialog open={createTeamOpen} onClose={() => setCreateTeamOpen(false)} />
			<CreateOrganizationDialog open={createOrganizationOpen} onClose={() => setCreateOrganizationOpen(false)} />
			<AccountDialog open={createAccountOpen} onClose={() => setCreateAccountOpen(false)} />
		</>
	);
}
